import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CardFooterComponent } from '../../../shared/card-footer/card-footer.component';
import { HeaderComponent } from '../../../shared/header/header.component';
import { EmployeeAuthService } from '../../../shared/services/employee-auth.service';
import { ErrorMessageService } from '../../../shared/services/error-message.service';

@Component({
  selector: 'app-username',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    HeaderComponent,
    CardFooterComponent,
    TranslateModule,
    CommonModule,
    RouterModule,
  ],
  templateUrl: './username.component.html',
  styleUrl: './username.component.css',
})
export class UsernameComponent implements OnInit {
  usernameForm: FormGroup;
  isLoading = false;
  errorMessage = '';

  constructor(
    private titleService: Title,
    private translate: TranslateService,
    private employeeAuthService: EmployeeAuthService,
    private router: Router,
    private fb: FormBuilder,
    private errorMessageService: ErrorMessageService
  ) {
    this.usernameForm = this.fb.group({
      policyNumber: ['', Validators.required],
      memberNumber: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe(() => {
      this.updateTitle();
    });
    this.updateTitle();
  }

  updateTitle(): void {
    this.translate.get('forgotUsername.title').subscribe((res: string) => {
      this.titleService.setTitle(res);
    });
  }

  onSubmit(): void {
    if (this.usernameForm.invalid) {
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    const { policyNumber, memberNumber } = this.usernameForm.value;

    this.employeeAuthService.recoverUsername(policyNumber, memberNumber).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (this.errorMessageService.isSuccessResponse(response) && response.data) {
          const sessionData = {
            sessionToken: response.data.sessionId,
            trxId: response.data.trxId,
            // The username recovery might not return an email, so we leave it empty.
            // The verify component will have to handle this case.
            email: '',
          };
          sessionStorage.setItem('employeeSessionData', JSON.stringify(sessionData));
          this.router.navigate(['/employee/account/verify'], { queryParams: { type: 'employee-username-recovery' } });
        } else {
          this.errorMessageService.getErrorMessage(response.errorCode).subscribe(message => {
            this.errorMessage = message;
          });
        }
      },
      error: (error) => {
        this.isLoading = false;
        if (error.error && error.error.errorCode) {
          this.errorMessageService.getErrorMessage(error.error.errorCode).subscribe(message => {
            this.errorMessage = message;
          });
        } else {
          this.translate.get('error.internalServerError').subscribe(message => {
            this.errorMessage = message;
          });
        }
      }
    });
  }
}
